import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { TextField } from "@material-ui/core";

const ModalCreate = ({
  isOpen,
  toggle,
  title,
  formId,
  token,
  infoModal,
  updateTable,
}) => {
  const [nuevoFormulario, setNuevoFormulario] = useState("");
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const validationTimeoutRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    setNuevoFormulario(infoModal ? infoModal.NumeroCaso : "");
    setIsDuplicate(false);
    setIsValidating(false);
  }, [infoModal]);

  const handleNumeroFormulario = (event) => {
    const value = event.target.value;
    setNuevoFormulario(value);
    setIsDuplicate(false);

    if (validationTimeoutRef.current) {
      clearTimeout(validationTimeoutRef.current);
    }

    if (token && value && value.length >= 4) {
      setIsValidating(true);

      // Debounce: esperar 500ms después de que el usuario deje de escribir
      validationTimeoutRef.current = setTimeout(() => {
        axios
          .get(`/formulario/numeroCaso/${value}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => {
            // Si encuentra el número, es duplicado
            setIsDuplicate(true);
            setIsValidating(false);
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: "El número de caso ingresado ya está registrado en el sistema",
              showCloseButton: true,
            });
          })
          .catch((error) => {
            // Si no encuentra (404), el número está disponible
            if (error.response?.status === 404) {
              setIsDuplicate(false);
            } else {
              // Otro error, permitir continuar pero notificar
              console.error("Error al validar:", error);
            }
            setIsValidating(false);
          });
      }, 500);
    } else {
      setIsValidating(false);
    }
  };

  const handleCreateSubmit = (event) => {
    event.preventDefault();

    if (isDuplicate) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "No se puede actualizar. El número de caso ya existe en el sistema",
        showCloseButton: true,
      });
      return; // DETENER EJECUCIÓN
    }

    if (!nuevoFormulario || nuevoFormulario.length < 4) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "Por favor ingrese un número de caso válido (mínimo 4 caracteres)",
        showCloseButton: true,
      });
      return;
    }

    // Enviar los datos del paciente y de los acompañantes
    axios
      .put(
        `/temporal/actualizacion/${formId}`,
        {
          NumeroFormulario: nuevoFormulario,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Creado!",
          text: "se ha modificado el numero de formulario exitosamente",
          showCloseButton: true,
        }).then(() => {
          toggle();
          updateTable();
          setNuevoFormulario("");
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Ha ocurrido un error al actualizar el numero de documento.",
          showCloseButton: true,
        }).then(() => {
          toggle();
          setNuevoFormulario("");
        });
      });
  };

  useEffect(() => {
    return () => {
      if (validationTimeoutRef.current) {
        clearTimeout(validationTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Modal ref={modalRef} isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <TextField
            label="Nuevo número de formulario"
            className="form-control "
            type="text"
            name="numeroFormulario"
            value={nuevoFormulario}
            onChange={handleNumeroFormulario}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Button
          onClick={handleCreateSubmit}
          color="primary"
          type="submit"
          disabled={
            isDuplicate ||
            isValidating ||
            !nuevoFormulario ||
            nuevoFormulario.length < 4
          }
        >
          {isValidating ? "Validando..." : "Actualizar"}
        </Button>
        <Button color="danger" onClick={() => toggle()}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalCreate;
